"use client";

import { GlobalContext } from "@/context";
import { useContext } from "react";
import CommandeContainer from "./CommandeContainer";
import Livraison from "./Livraison";
import PaymentMethod from "./PaymentMethod";

const PanierSelector = () => {
  const { panierStatus, setPanierStatus } = useContext(GlobalContext);
  return (
    <div className="w-[90%] mx-auto">
    <h1 className="text-[17px] lg:text-[40px] font-semibold text-[#FF0000] pl-28">
      {panierStatus==1? "Mon panier":panierStatus==2? "Livraison" :"Paiement"}
    </h1>
    <div className="pt-24 pb-2 flex flex-col gap-12 w-full rounded-[96px] border-[2px] border-[#707070] bg-[#FFFFFF] h-full">      {panierStatus == 1 ? (
        <CommandeContainer />
      ) : panierStatus == 2 ? (
        <Livraison />
      ) : (
        <PaymentMethod />
      )}
    </div>
    </div>
  );
};

export default PanierSelector;
